/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDepositPaymentDetail_item = {
    readonly serviceId: string | null;
    readonly isDepositAvailable: boolean;
    readonly " $refType": "PdpSharedDepositPaymentDetail_item";
};
export type PdpSharedDepositPaymentDetail_item$data = PdpSharedDepositPaymentDetail_item;
export type PdpSharedDepositPaymentDetail_item$key = {
    readonly " $data"?: PdpSharedDepositPaymentDetail_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDepositPaymentDetail_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDepositPaymentDetail_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isDepositAvailable",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "storageKey": null
    }
  ]
};
(node as any).hash = '2b79e2b42ebb3c9746128ed3d5a4f7b0';
export default node;
